import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withNamespaces } from "react-i18next";
import { Modal } from "react-bootstrap";
import Spinner from "~/components/Spinner";
import { getIflowFormdata } from "store/ducks/processes/actionTypes";
import NativeProcessesWrapper from "~/components/ProcessosFormHandler/NativeProcessesWrapper";

import oauth from "~/utils/oauth";
import "./scss/flowModal.scss";

const FlowModal = (props) => {
  const {
    t,
    src,
    app,
    process,
    showModal,
    closeModal,
    processNumber = "",
    isPortal = false,
    styleSheetLink,
  } = props;

  const dispatch = useDispatch();
  const { menu } = useSelector((state) => state.applicationMenuReducer);
  const { isLoadingFormdata } = useSelector((state) => state.processesReducer);

  const [modalClassName, setModalClassName] = useState("modal-tarefa-80w");
  const [iframeClassName, setIframeClassName] = useState("iframe-tarefa-80w");
  const [iconClassName, setIconClassName] = useState("icon-maximize mr-4");
  const [isMaximized, setIsMaximised] = useState(false);

  const [styleSheet, setFormStyleSheet] = useState("");
  const [headerName, setHeaderName] = useState("");

  useEffect(() => {
    if (!menu) return;
    const menuItem = menu.find(
      (item) => item.route === `${app}/tarefas` || item.route === `${app}/tasks`
    );
    if (menuItem) {
      const extraConfiguration_ = JSON.parse(
        menuItem.extraConfiguration || false
      );
      const maximize = extraConfiguration_.maximize;
      if (!maximize || maximize == "false") {
        return;
      }
      setIsMaximised(true);
      setModalClassName("modal-tarefa-100w");
      setIconClassName("icon-restore mr-4");
    }
  }, [menu]);

  const handleClick = () => {
    modalClassName === "modal-tarefa-80w"
      ? setModalClassName("modal-tarefa-100w")
      : setModalClassName("modal-tarefa-80w");
    iframeClassName === "iframe-tarefa-80w"
      ? setIframeClassName("iframe-tarefa-100w")
      : setIframeClassName("iframe-tarefa-80w");
    iconClassName === "icon-maximize mr-4"
      ? setIconClassName("icon-restore mr-4")
      : setIconClassName("icon-maximize mr-4");
  };

  const handleClose = () => {
    if (isMaximized) {
      setModalClassName("modal-tarefa-100w");
      setIconClassName("icon-restore mr-4");
    } else {
      setModalClassName("modal-tarefa-80w");
      setIconClassName("icon-maximize mr-4");
    }
    setIframeClassName("iframe-tarefa-80w");
    closeModal();
  };

  useEffect(() => {
    if (!isPortal) {
      if (menu && app && process && process.url !== "") {
        const menuItem = menu.find((item) => item.route === `${app}/processos`);
        if (menuItem) {
          const extraConfiguration_ = JSON.parse(
            menuItem.extraConfiguration || false
          );
          const nativeFlows_ = extraConfiguration_.nativeFlows;
          if (nativeFlows_ && process.url) {
            if (
              nativeFlows_.some((flow) =>
                process.url.includes(`flowid=${flow}`)
              )
            ) {
              const payload = {
                url: process.url + "&Authorization=" + oauth.getAccessToken(),
              };
              dispatch(getIflowFormdata(payload));
            }
          }

          const styleSheet_ =
            extraConfiguration_ && extraConfiguration_.styleSheet;

          setFormStyleSheet(styleSheet_);
        }
      }
    } else {
      if (menu && process) {
        if (process?.flow_id && process?.p_id && process?.subp_id) {
          const flowid = process.flow_id;
          const pid = process.p_id;
          const subpid = process.subp_id;
          //default url
          let url =
            `/Form/form.jsp?flowid=${flowid}&pid=${pid}&subpid=${subpid}&Authorization=` +
            oauth.getAccessToken();
          if (
            window.location.href.includes("portalrh/personalarea/generic") ||
            window.location.href.includes("portalrh/personalarea/vacations") ||
            window.location.href.includes("portalrh/personalarea/expense") ||
            window.location.href.includes("personalarea/requests/payment")
          ) {
            url =
              `/Form/detail.jsp?flowid=${flowid}&pid=${pid}&subpid=${subpid}&procStatus=0&fwSearch=true` +
              "&Authorization=" +
              oauth.getAccessToken();
          } else if (
            window.location.href.includes("portalrh/myteam/generic") ||
            window.location.href.includes("portalrh/myteam/expense")
          ) {
            url =
              `/Forward/forward.jsp?flowid=${flowid}&pid=${pid}&subpid=${subpid}&procStatus=0&fwSearch=true` +
              "&Authorization=" +
              oauth.getAccessToken();
          }
          dispatch(getIflowFormdata({ url }));
        }
      }
    }
  }, [menu, app, process]);

  const renderContent = () => {
    if (styleSheetLink) {
      return (
        <NativeProcessesWrapper
          isModal={true}
          handleClose={handleClose}
          handleHeaderName={setHeaderName}
        />
      );
    }
    if (!isPortal) {
      if (menu && src !== "") {
        const menuItem = menu.find((item) => item.route === `${app}/processos`);
        if (menuItem) {
          const extraConfiguration_ = JSON.parse(
            menuItem.extraConfiguration || false
          );
          const nativeFlows_ = extraConfiguration_.nativeFlows;
          console.log(extraConfiguration_)
          console.log(src)
          if (nativeFlows_ && src) {
            if (nativeFlows_.some((flow) => src.includes(`flowid=${flow}`))) {
              return (
                <NativeProcessesWrapper
                  isModal={true}
                  handleHeaderName={setHeaderName}
                  handleClose={handleClose}
                />
              );
            } else
              return <TaskIframe src={src} iframeClassName={iframeClassName} />;
          } else
            return <TaskIframe src={src} iframeClassName={iframeClassName} />;
        } else
          return <TaskIframe src={src} iframeClassName={iframeClassName} />;
      }
    } else {
      if (menu && src !== "") {
        return (
          <NativeProcessesWrapper
            isModal={true}
            handleClose={handleClose}
            handleHeaderName={setHeaderName}
          />
        );
      }
    }
  };

  return !isLoadingFormdata ? (
    <Modal
      dialogClassName={modalClassName + " custom-modal"}
      show={showModal}
      onHide={closeModal}
      backdrop="static"
      scrollable
    >
      <Modal.Header className="justify-content-between">
        <div className="custom-title ml-4">
          {styleSheetLink
            ? t("taskPage.general.processDetail") 
            : styleSheet?.hideFormHeader
            ? headerName 
            : t("taskPage.general.process") + " " + processNumber}
        </div>
        <div>
          <i className={iconClassName} onClick={() => handleClick()} />
          <i className="icon-remove mr-4" onClick={() => handleClose()} />
        </div>
      </Modal.Header>

      <Modal.Body
        style={{ padding: "0px", scrollY: "auto" }}
        className={styleSheet?.processScroll ? "scrollBar-visible" : ""}
      >
        {renderContent()}
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  ) : (
    <Spinner spinning={isLoadingFormdata} wrapper />
  );
};

const TaskIframe = ({ src, iframeClassName }) => {
  console.log(src)
  return (
    <iframe
      id="process"
      title="process-flow"
      src={src}
      className={iframeClassName}
    />
  );
};

export default withNamespaces()(FlowModal);
